import Cookies from 'js-cookie';

const cookies = Cookies.withAttributes({
  expires: 365,
  domain: process.env.PREACT_APP_COOKIE_DOMAIN,
  path: '/',
  sameSite: 'Lax',
  secure: process.env.NODE_ENV === 'production', // HTTPS only in production
});

export const getCookie = (name: string) => {
  return cookies.get(name);
};

export const setCookie = (name: string, value: string) => {
  cookies.set(name, value);
};

export const getOrSetCookie = (name: string, defaultValue: string | (() => string), forceSet = false) => {
  const currentValue = getCookie(name);
  if (currentValue && !forceSet) {
    return currentValue;
  }
  const value = currentValue ?? (typeof defaultValue === 'function' ? defaultValue() : defaultValue);
  setCookie(name, value);
  return value;
};

export const removeCookie = (name: string) => {
  cookies.remove(name);
};
